import {valueMatches, valuesMatch} from '../../common/filters.js';
import {IOGateway} from '../../../gateway';

export function publisherMatches(publisherFilter: Record<string, IOGateway.Filtering.Matcher>,
                                 repoId: IOGateway.Metrics.Identity): boolean {
    for (const [k, v] of Object.entries(publisherFilter)) {
        const rv = repoId[k];
        if (!valueMatches(v, rv)) {
            return false;
        }
    }
    return true;
}

export function metricMatches(metricFilter: IOGateway.Filtering.Matcher[],
                              name: IOGateway.Metrics.Name): boolean {
    return valuesMatch(metricFilter, name);
}

export function isAllowed(repoId: IOGateway.Metrics.Identity,
                          name: IOGateway.Metrics.Name,
                          filters?: IOGateway.MetricFilters): boolean {
    const result = filters?.publishers?.reduce((r: boolean | undefined, filterConfig) => {
        if (publisherMatches(filterConfig.identity, repoId)) {
            const blocked = filterConfig.metrics.block ?? filterConfig.metrics.blacklist ?? [];
            if (blocked.length > 0 && metricMatches(blocked, name)) {
                return false;
            } else {
                const allowed = filterConfig.metrics.allow ?? filterConfig.metrics.whitelist ?? [];
                return r || metricMatches(allowed, name);
            }
        }
        return r;
    }, undefined);
    if (result !== undefined) {
        return result;
    }
    const nonMatched: IOGateway.Filtering.Action = filters?.non_matched ?? 'allow';
    return nonMatched === 'allow' || nonMatched === 'whitelist';
}
